import React from 'react';
import { 
  HelpCircle, 
  FileText, 
  Landmark, 
  Clock, 
  Shield, 
  Award, 
  TrendingUp,
  Wheat
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: FileText,
      title: 'Подготовка документов',
      description: 'Заранее подготовьте полный пакет документов: учредительные документы, бизнес-план, бухгалтерскую отчетность.'
    },
    {
      icon: Landmark,
      title: 'Выбор программы',
      description: 'Одновременно можно участвовать в нескольких программах поддержки, но важно соблюдать требования каждой из них.'
    },
    {
      icon: Clock,
      title: 'Сроки подачи',
      description: 'Уточните сроки приема заявок. Большинство программ имеют строго ограниченные периоды подачи документов.'
    },
    {
      icon: Shield,
      title: 'Целевое использование',
      description: 'Все полученные средства должны быть использованы строго по целевому назначению и подтверждены документально.'
    },
    {
      icon: Award,
      title: 'Рейтинговый отбор',
      description: 'Многие субсидии предоставляются на конкурсной основе. Обратите внимание на критерии отбора заявок.'
    },
    {
      icon: TrendingUp,
      title: 'Софинансирование',
      description: 'Большинство программ требуют софинансирования части затрат со стороны получателя (обычно 20-60%).'
    },
    {
      icon: Wheat,
      title: 'Экологические стандарты',
      description: 'Соответствие экологическим стандартам дает дополнительные баллы при рассмотрении заявок на субсидии.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по получению субсидий
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              Получите индивидуальную консультацию по доступным для вашего региона программам субсидирования сельского хозяйства.
            </p>
            <button className="w-full py-1.5 text-xs bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors">
              Записаться на консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;